import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Select, { components, defaultTheme } from 'react-select';
import PropTypes from 'prop-types';
import AsyncCreatableSelect from 'react-select/async-creatable';
import plus from '../../../../assets/images/qualifications-plus.svg';
import plusAlt from '../../../../assets/images/qualifications-plus-alt.svg';
import plusDisabled from '../../../../assets/images/qualifications-plus-disabled.svg';
import x from '../../../../assets/images/x.svg';
import xDark from '../../../../assets/images/x-dark.svg';
import './ExpertiseTagDropdown.scss';
var colors = defaultTheme.colors;
var maxItems = 100;
var displayOtherText = function displayOtherText(model) {
  switch (model) {
    case 'higher_level_role':
      return 'Can\'t find what you\'re looking for? Select "Other" to proceed.';
    case 'area_of_expertise':
      return 'Can\'t find what you\'re looking for? Type and Select "Other" to proceed.';
    default:
      return 'Click "Not Applicable" if this section is not relevant in candidate evaluation.';
  }
};
var selectStyles = {
  control: function control(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      minWidth: 240,
      maxWidth: 400,
      margin: 8
    });
  },
  menu: function menu() {
    return {
      maxWidth: 400
    };
  }
};

// styled components

var menuFooterStyle = {
  padding: '8px 12px',
  background: '#f2f3f7',
  color: '#5d5d5d',
  maxWidth: 400
};
function CheckboxOption(props) {
  var _props$options$find = props.options.find(function (opt) {
      return opt.value === props.value;
    }),
    description = _props$options$find.description;
  return /*#__PURE__*/React.createElement(components.Option, props, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: props.isSelected,
    onChange: function onChange() {
      return null;
    },
    name: "option-".concat(props.value),
    className: "checkbox-option"
  }), /*#__PURE__*/React.createElement("label", {
    className: "medium-weight checkbox-option-label pl-5",
    htmlFor: "option-".concat(props.value)
  }, props.label), /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 ms-3 checkbox-option-description"
  }, description));
}
function Menu(props) {
  var children = props.children,
    isCreatable = props.isCreatable,
    showFooter = props.showFooter;
  var dataModel = children.props['data-model'];
  return /*#__PURE__*/React.createElement("div", {
    css: {
      backgroundColor: 'white',
      borderRadius: 4,
      marginTop: 8,
      position: 'absolute',
      zIndex: 2
    }
  }, children, showFooter ? /*#__PURE__*/React.createElement("div", {
    style: menuFooterStyle
  }, isCreatable ? "Can't find it from the list? Type your keyword to create a new one." : displayOtherText(dataModel)) : '');
}
Menu.propTypes = {
  children: PropTypes.node.isRequired,
  isCreatable: PropTypes.bool.isRequired,
  showFooter: PropTypes.bool.isRequired
};
function Blanket(props) {
  return /*#__PURE__*/React.createElement("div", _extends({
    css: {
      bottom: 0,
      left: 0,
      top: 0,
      right: 0,
      position: 'fixed',
      zIndex: 1
    }
  }, props));
}
function Dropdown(_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    target = _ref.target,
    onClose = _ref.onClose,
    isCreatable = _ref.isCreatable,
    showMenuFooter = _ref.showMenuFooter;
  return /*#__PURE__*/React.createElement("div", {
    className: "expertise-tag-dropdown-container ".concat(isOpen ? 'open' : '')
  }, target, isOpen ? /*#__PURE__*/React.createElement(Menu, {
    isCreatable: isCreatable,
    showFooter: showMenuFooter
  }, children) : null, isOpen ? /*#__PURE__*/React.createElement(Blanket, {
    onClick: onClose
  }) : null);
}
Dropdown.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isCreatable: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  target: PropTypes.node.isRequired,
  showMenuFooter: PropTypes.bool.isRequired
};
function Svg(p) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    focusable: "false",
    role: "presentation"
  }, p));
}
function DropdownIndicator() {
  return /*#__PURE__*/React.createElement("div", {
    css: {
      color: colors.neutral20,
      height: 24,
      width: 32
    },
    className: "me-2"
  }, /*#__PURE__*/React.createElement(Svg, null, /*#__PURE__*/React.createElement("path", {
    d: 'M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 ' + '7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z',
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
var groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
};
var groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center'
};
var formatGroupLabel = function formatGroupLabel(data) {
  return /*#__PURE__*/React.createElement("div", {
    style: groupStyles
  }, /*#__PURE__*/React.createElement("span", null, data.label), /*#__PURE__*/React.createElement("span", {
    style: groupBadgeStyles
  }, data.options.length));
};
var formatGroupOptions = function formatGroupOptions(options) {
  var grouped = options.reduce(function (result, item) {
    var category = item.category || 'Others'; // Default to 'Others' if category is missing

    if (!result[category]) {
      result[category] = [];
    }
    result[category].push(item);
    return result;
  }, {});

  // Step 2: Convert grouped data to the required format
  return Object.keys(grouped).map(function (category) {
    return {
      label: category,
      options: grouped[category]
    };
  });
};
var ExpertiseTagDropdown = /*#__PURE__*/function (_Component) {
  function ExpertiseTagDropdown(props) {
    var _this;
    _classCallCheck(this, ExpertiseTagDropdown);
    _this = _callSuper(this, ExpertiseTagDropdown, [props]);
    _this.state = {
      isOpen: props.menuIsOpen
    };
    _this.handleRemoveSelection = _this.handleRemoveSelection.bind(_this);
    return _this;
  }
  _inherits(ExpertiseTagDropdown, _Component);
  return _createClass(ExpertiseTagDropdown, [{
    key: "handleRemoveSelection",
    value: function handleRemoveSelection(val) {
      var _this$props = this.props,
        handleSelect = _this$props.handleSelect,
        selection = _this$props.selection,
        model = _this$props.model,
        multi = _this$props.multi;
      return function () {
        var newSelection = _toConsumableArray(selection).filter(function (item) {
          return item.value !== val;
        });
        handleSelect(model, multi)(newSelection);
      };
    }
  }, {
    key: "renderTags",
    value: function renderTags() {
      var _this2 = this;
      var _this$props2 = this.props,
        selection = _this$props2.selection,
        model = _this$props2.model,
        handleRemove = _this$props2.handleRemove;
      if (!selection) return null;
      return selection.map(function (item, idx) {
        return /*#__PURE__*/React.createElement("div", {
          className: "qualification-tag ".concat(model, "-tag-display"),
          key: "".concat(item.value, "-").concat(idx)
        }, /*#__PURE__*/React.createElement("div", {
          className: "expertise-tag-label"
        }, item.label), /*#__PURE__*/React.createElement("div", {
          className: "remove-link",
          role: "button",
          tabIndex: 0,
          onClick: handleRemove ? function () {
            return handleRemove(item.value);
          } : _this2.handleRemoveSelection(item.value)
        }, /*#__PURE__*/React.createElement("img", {
          src: x,
          alt: "remove"
        })));
      });
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      var _this3 = this;
      var _this$props3 = this.props,
        model = _this$props3.model,
        isDisabled = _this$props3.isDisabled,
        selection = _this$props3.selection,
        heading = _this$props3.heading,
        menuHeading = _this$props3.menuHeading,
        multi = _this$props3.multi,
        ctaVerb = _this$props3.ctaVerb,
        plusColor = _this$props3.plusColor;
      var isOpen = this.state.isOpen;
      var disabled = isDisabled || !multi && selection && selection.length;
      var plusImg = plus;
      if (disabled) {
        plusImg = plusDisabled;
      } else if (plusColor === 'alt') {
        plusImg = plusAlt;
      }
      if (isOpen) {
        return /*#__PURE__*/React.createElement("div", {
          className: "open-dropdown-heading"
        }, /*#__PURE__*/React.createElement("div", {
          className: "open-dropdown-text"
        }, menuHeading || (multi ? 'Select 1 or more options' : 'Select 1 option')), /*#__PURE__*/React.createElement("div", {
          className: "close-dropdown",
          onClick: function onClick() {
            return _this3.setState({
              isOpen: false
            });
          },
          role: "button",
          tabIndex: 0
        }, /*#__PURE__*/React.createElement("img", {
          alt: "close",
          src: xDark
        })));
      }
      return /*#__PURE__*/React.createElement(Button, {
        className: "expertise-tag-dropdown-button add-".concat(model, "-button ").concat(disabled && 'disabled'),
        onClick: function onClick() {
          return !disabled && _this3.setState({
            isOpen: !isOpen
          });
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: plusImg,
        alt: "add"
      }), /*#__PURE__*/React.createElement("div", {
        className: "caption ".concat(disabled && 'disabled')
      }, ctaVerb, ' ', heading));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props4 = this.props,
        model = _this$props4.model,
        selection = _this$props4.selection,
        handleSelect = _this$props4.handleSelect,
        multi = _this$props4.multi,
        handleCreate = _this$props4.handleCreate,
        isValidNewOption = _this$props4.isValidNewOption,
        loadOptions = _this$props4.loadOptions,
        heading = _this$props4.heading,
        isDisabled = _this$props4.isDisabled,
        picklist = _this$props4.picklist,
        isCreatable = _this$props4.isCreatable,
        checkboxOptions = _this$props4.checkboxOptions,
        showSubHeading = _this$props4.showSubHeading,
        showMenuFooter = _this$props4.showMenuFooter,
        bodyClass = _this$props4.bodyClass,
        groupStyle = _this$props4.groupStyle;
      var isOpen = this.state.isOpen;
      var selectComponents = {
        DropdownIndicator: DropdownIndicator,
        IndicatorSeparator: function IndicatorSeparator() {
          return null;
        }
      };
      if (checkboxOptions) {
        selectComponents.Option = CheckboxOption;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: bodyClass
      }, /*#__PURE__*/React.createElement("div", {
        className: "expertise-tag-dropdown-heading"
      }, heading, ['area_of_expertise', 'higher_level_role', 'level'].includes(model) && /*#__PURE__*/React.createElement("div", {
        className: "heading-required"
      }, "* Required"), heading === 'Role' && showSubHeading && /*#__PURE__*/React.createElement("div", {
        className: "input-sub-heading"
      }, "Roles are used to standardize project titles across the life sciences.", /*#__PURE__*/React.createElement("br", null), "Example: Data Management Leader")), /*#__PURE__*/React.createElement("div", {
        className: "tags-container"
      }, this.renderTags()), /*#__PURE__*/React.createElement(Dropdown, {
        isOpen: isOpen,
        onClose: function onClose() {
          return _this4.setState({
            isOpen: false
          });
        },
        target: this.renderButton(),
        isCreatable: isCreatable,
        showMenuFooter: showMenuFooter
      }, groupStyle ? /*#__PURE__*/React.createElement(Select, {
        autoFocus: true,
        onBlur: function onBlur() {
          return _this4.setState({
            isOpen: false
          });
        },
        tabIndex: 0,
        backspaceRemovesValue: false,
        components: selectComponents,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        menuIsOpen: isOpen,
        styles: selectStyles,
        "data-model": model,
        classNamePrefix: "clora-multiselect",
        closeMenuOnSelect: false,
        value: selection,
        limit: multi ? null : 1,
        className: "project-expertise-select",
        id: "project-expertise-select-".concat(model),
        onChange: function onChange(newValue) {
          handleSelect(model, multi)(newValue);
          _this4.setState({
            isOpen: false
          });
        },
        tabSelectsValue: false,
        isDisabled: isDisabled,
        placeholder: "Search...",
        marginTop: "5",
        defaultOptions: picklist.slice(0, maxItems),
        isValidNewOption: isValidNewOption,
        onCreateOption: handleCreate(model, multi),
        isMulti: true,
        formatGroupLabel: formatGroupLabel,
        options: formatGroupOptions(picklist)
      }) : /*#__PURE__*/React.createElement(AsyncCreatableSelect, {
        autoFocus: true,
        onBlur: function onBlur() {
          return _this4.setState({
            isOpen: false
          });
        },
        tabIndex: 0,
        backspaceRemovesValue: false,
        components: selectComponents,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        menuIsOpen: isOpen,
        styles: selectStyles,
        "data-model": model,
        classNamePrefix: "clora-multiselect",
        closeMenuOnSelect: false,
        value: selection,
        limit: multi ? null : 1,
        className: "project-expertise-select",
        id: "project-expertise-select-".concat(model),
        onChange: function onChange(newValue) {
          handleSelect(model, multi)(newValue);
          _this4.setState({
            isOpen: false
          });
        },
        tabSelectsValue: false,
        isDisabled: isDisabled,
        placeholder: "Search...",
        marginTop: "5",
        defaultOptions: picklist.slice(0, maxItems),
        cacheOptions: true,
        isValidNewOption: isValidNewOption,
        loadOptions: loadOptions,
        onCreateOption: handleCreate(model, multi),
        isMulti: true
      })));
    }
  }]);
}(Component);
ExpertiseTagDropdown.propTypes = {
  model: PropTypes.string.isRequired,
  selection: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleSelect: PropTypes.func.isRequired,
  handleCreate: PropTypes.func,
  handleRemove: PropTypes.func,
  multi: PropTypes.bool,
  isValidNewOption: PropTypes.func,
  isCreatable: PropTypes.bool,
  heading: PropTypes.string,
  menuHeading: PropTypes.string,
  isDisabled: PropTypes.bool,
  menuIsOpen: PropTypes.bool,
  picklist: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loadOptions: PropTypes.func.isRequired,
  checkboxOptions: PropTypes.bool,
  showSubHeading: PropTypes.bool,
  showMenuFooter: PropTypes.bool,
  groupStyle: PropTypes.bool,
  ctaVerb: PropTypes.string,
  bodyClass: PropTypes.string,
  plusColor: PropTypes.string
};
ExpertiseTagDropdown.defaultProps = {
  multi: true,
  handleCreate: function handleCreate() {},
  isValidNewOption: function isValidNewOption() {},
  heading: '',
  isDisabled: false,
  menuIsOpen: false,
  isCreatable: false,
  menuHeading: null,
  checkboxOptions: false,
  showSubHeading: true,
  showMenuFooter: true,
  ctaVerb: 'Add ',
  bodyClass: 'mt-2 mb-2',
  plusColor: 'default',
  handleRemove: null,
  groupStyle: false
};
export default ExpertiseTagDropdown;